// removed by extract-text-webpack-plugin
module.exports = {"root":"NotFound__root--1gmEq","icon":"NotFound__icon--1LhfZ","description":"NotFound__description--1zPLg","button":"NotFound__button--nFr0l","bounce":"NotFound__bounce--13piK"};


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/components/NotFound/NotFound.css
// module id = ./src/dashboard/components/NotFound/NotFound.css
// module chunks = 1